export interface WizardPlanLimits {
  maxLocations: number
  maxLeaveTypes: number
  maxDepartments: number
  minLeaveDuration: 'FULL-DAY' | 'HALF-DAY' | 'ONE-HOUR' | 'HALF-HOUR' | '15MIN'
}

const FREEMIUM_LIMITS: WizardPlanLimits = {
  maxLocations: 1,
  maxLeaveTypes: 1,
  maxDepartments: 1,
  minLeaveDuration: 'HALF-DAY',
}

const CORE_LIMITS: WizardPlanLimits = {
  maxLocations: 3,
  maxLeaveTypes: Infinity,
  maxDepartments: 10,
  minLeaveDuration: 'HALF-DAY',
}

const COMPLETE_LIMITS: WizardPlanLimits = {
  maxLocations: Infinity,
  maxLeaveTypes: Infinity,
  maxDepartments: Infinity,
  minLeaveDuration: '15MIN',
}

export const getWizardPlanLimits = (plan?: string | null): WizardPlanLimits => {
  switch (plan?.toLowerCase()) {
    case 'complete':
    case 'enterprise':
      return COMPLETE_LIMITS
    case 'core':
      return CORE_LIMITS
    default:
      return FREEMIUM_LIMITS
  }
}
